var AssetDirectory = {
	"preloader": [
		"assets/font/preloader/exo-bold.ttf",
		"assets/font/preloader/exo-medium.ttf",
		"assets/font/preloader/proximanova-black.ttf",
		"assets/images/preloader/loader/gfx_bg.png",
		"assets/images/preloader/loader/gfx_loading.png",
		"assets/images/preloader/loader/gizmoloading.json",
		"assets/images/preloader/loader/gizmoloading_ske.json",
		"assets/images/preloader/loader/gizmoloading_tex.json",
		"assets/images/preloader/loader/gizmoloading_tex.png",
		"assets/sounds/preloader/loader/bgm/game_bgm.ogg",
		"assets/sounds/preloader/loader/sfx/button_sfx.ogg",
		"assets/sounds/preloader/loader/sfx/score_points.ogg",
		"assets/sounds/preloader/loader/sfx/star_gain.ogg",
		"assets/strings/preloader/strings.json"
	],
	"undefined": [
		"assets/.DS_Store",
		"assets/images/.DS_Store"
	],
	".DS_Store": [
		"assets/images/external/.DS_Store"
	],
	"game": [
		"assets/images/external/game/10.png",
		"assets/images/external/game/10a.png",
		"assets/images/external/game/10b.png",
		"assets/images/external/game/20.png",
		"assets/images/external/game/20a.png",
		"assets/images/external/game/20b.png",
		"assets/images/external/game/30.png",
		"assets/images/external/game/30a.png",
		"assets/images/external/game/30b.png",
		"assets/images/external/game/40.png",
		"assets/images/external/game/40a.png",
		"assets/images/external/game/40b.png",
		"assets/images/external/game/50.png",
		"assets/images/external/game/50a.png",
		"assets/images/external/game/50b.png",
		"assets/images/external/game/bg_ingame.png",
		"assets/images/external/game/burst_fx/burst_fx_ske.json",
		"assets/images/external/game/burst_fx/burst_fx_tex.json",
		"assets/images/external/game/burst_fx/burst_fx_tex.png",
		"assets/images/external/game/disc1a.png",
		"assets/images/external/game/disc1b.png",
		"assets/images/external/game/disc2a.png",
		"assets/images/external/game/disc2b.png",
		"assets/images/external/game/grid1a.png",
		"assets/images/external/game/grid1b.png",
		"assets/images/external/game/grid2a.png",
		"assets/images/external/game/grid2b.png",
		"assets/images/external/game/grid3a.png",
		"assets/images/external/game/grid3b.png",
		"assets/images/external/game/grid_base.png",
		"assets/images/external/game/gridglow1.png",
		"assets/images/external/game/gridglow2.png",
		"assets/images/external/game/meter_bar.png",
		"assets/images/external/game/meter_container.png",
		"assets/images/external/game/mid.png",
		"assets/images/external/game/pickup/fx_pickup_ske.json",
		"assets/images/external/game/pickup/fx_pickup_tex.json",
		"assets/images/external/game/pickup/fx_pickup_tex.png",
		"assets/images/external/game/pickup1.png",
		"assets/images/external/game/pickup2.png",
		"assets/images/external/game/pickup3.png",
		"assets/images/external/game/shadow1.png",
		"assets/images/external/game/shadow2.png",
		"assets/images/external/game/shadow3.png",
		"assets/images/external/game/slide.png",
		"assets/images/external/game/top.png",
		"assets/sounds/external/game/disc.ogg",
		"assets/sounds/external/game/gridselect.ogg",
		"assets/sounds/external/game/lose.ogg",
		"assets/sounds/external/game/pattern.ogg",
		"assets/sounds/external/game/pickup.ogg",
		"assets/sounds/external/game/success.ogg"
	],
	"title": [
		"assets/images/external/title/game_title.png",
		"assets/images/external/title/title_background.png"
	],
	"ui": [
		"assets/images/external/ui/btn_audio1.png",
		"assets/images/external/ui/btn_audio2.png",
		"assets/images/external/ui/btn_audio3.png",
		"assets/images/external/ui/btn_audio4.png",
		"assets/images/external/ui/btn_close.png",
		"assets/images/external/ui/btn_exit.png",
		"assets/images/external/ui/btn_exit2.png",
		"assets/images/external/ui/btn_pause.png",
		"assets/images/external/ui/btn_pause2.png",
		"assets/images/external/ui/btn_play.png",
		"assets/images/external/ui/btn_play2.png",
		"assets/images/external/ui/btn_prevnext.png",
		"assets/images/external/ui/btn_prevnext2.png",
		"assets/images/external/ui/btn_return.png",
		"assets/images/external/ui/btn_return2.png",
		"assets/images/external/ui/check-button1.png",
		"assets/images/external/ui/check-button2.png",
		"assets/images/external/ui/gfx_container.png",
		"assets/images/external/ui/gfx_container_white.png",
		"assets/images/external/ui/gfx_explode.png",
		"assets/images/external/ui/gfx_flare_long.png",
		"assets/images/external/ui/gfx_flare_star.png",
		"assets/images/external/ui/gfx_loading_bar_con.png",
		"assets/images/external/ui/gfx_pop.png",
		"assets/images/external/ui/gfx_pop2.png",
		"assets/images/external/ui/gfx_star0.png",
		"assets/images/external/ui/gfx_star1.png",
		"assets/images/external/ui/gfx_starbg.png",
		"assets/images/external/ui/htp1.png",
		"assets/images/external/ui/htp2.png",
		"assets/images/external/ui/htp3.png",
		"assets/images/external/ui/x-button1.png",
		"assets/images/external/ui/x-button2.png"
	]
};